import React from "react";
import { FormSpy } from "react-final-form";
import {
  eachMinuteOfInterval,
  endOfDay,
  format,
  getHours,
  getMinutes,
  startOfDay,
} from "date-fns";

import { Button, Typography } from "@material-ui/core";

import FormControl, {
  DateFieldControl,
  SwitchFieldControl,
} from "components/FormControl";
import LoadingButton from "components/LoadingButton";
import SubmitButtonControl from "components/FormControl/SubmitButtonControl";
import Row from "components/Form/Row";
import DropdownFieldControl from "components/FormControl/DropdownFieldControl";

import { DEFAULT_TIMEZONE_TEXT } from "constants/dateConstants";

import {
  Container,
  TitleWrapper,
  TitleContainer,
  Column,
  ControlRow,
  TimeControlWrapper,
  TextWrapper,
  ButtonContainer,
  Buttons,
} from "./styles";

type FormSubmitData = {
  values: any;
};

type Props = {
  onSubmit: (data: FormSubmitData) => void;
  onClose: () => void;
  isLoading?: boolean;
  scheduleInfoText?: string;
};

class PublishAllContentForm extends React.Component<Props> {
  get timeDropdownOptions() {
    const date = startOfDay(new Date());

    return eachMinuteOfInterval(
      { start: date, end: endOfDay(date) },
      { step: 30 },
    ).map((dateWithTime: Date) => {
      const timeText = format(dateWithTime, "hh:mm a");
      return {
        value: getHours(dateWithTime) * 60 + getMinutes(dateWithTime),
        label: timeText,
      };
    });
  }

  render() {
    const { onClose, onSubmit, scheduleInfoText } = this.props;

    return (
      <FormControl onSubmit={onSubmit}>
        <Container>
          <Row>
            <TitleWrapper>
              <TitleContainer>
                <Typography variant="h1">Publish Changes</Typography>
              </TitleContainer>
              <Typography variant="subtitle1">
                Would you like to publish the updated content to production?
              </Typography>
              {scheduleInfoText && (
                <Typography variant="subtitle1">{scheduleInfoText}</Typography>
              )}
            </TitleWrapper>
          </Row>

          <FormSpy subscription={{ values: true }}>
            {({ values }) => (
              <>
                <ControlRow>
                  <SwitchFieldControl
                    name="isScheduleLater"
                    label="Schedule later"
                    color="primary"
                    size="small"
                  />
                </ControlRow>

                {values.isScheduleLater && (
                  <Row>
                    <Column>
                      <DateFieldControl
                        name="scheduleDate"
                        title="Schedule date"
                        inputVariant="outlined"
                        margin="none"
                        fullWidth
                        required
                      />
                    </Column>
                    <Column>
                      <TimeControlWrapper>
                        <DropdownFieldControl
                          name="scheduleTimeMinutes"
                          options={this.timeDropdownOptions}
                          label="Time"
                          placeholder="Select time"
                          required
                        />
                        <TextWrapper>
                          <Typography variant="subtitle1" color="secondary">
                            {DEFAULT_TIMEZONE_TEXT}
                          </Typography>
                        </TextWrapper>
                      </TimeControlWrapper>
                    </Column>
                  </Row>
                )}
              </>
            )}
          </FormSpy>
        </Container>

        <Buttons>
          <ButtonContainer>
            <Button
              variant="outlined"
              color="primary"
              onClick={onClose}
              fullWidth
            >
              Cancel
            </Button>
          </ButtonContainer>
          <ButtonContainer>
            <SubmitButtonControl render={this.renderButton} />
          </ButtonContainer>
        </Buttons>
      </FormControl>
    );
  }

  renderButton = ({ onClick }: { onClick: () => void }) => (
    <LoadingButton
      onClick={onClick}
      variant="contained"
      color="primary"
      isLoading={this.props.isLoading}
      fullWidth
    >
      Publish
    </LoadingButton>
  );
}

export default PublishAllContentForm;
